import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OrderedSet } from 'immutable';
import ReportSummaryStyles from './report_summary_styles';
import UserModel from '../../../../session/models/user_model';
import TotalsSummary from './totals_summary';
import PathwayInstanceSummary from './pathway_instance_summary';

const propTypes = {
  pathways: PropTypes.instanceOf(OrderedSet).isRequired,
  pathwayInstances: PropTypes.instanceOf(OrderedSet).isRequired,
  listPathwayInstances: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(UserModel).isRequired,
  organizationId: PropTypes.string.isRequired,
};

const defaultProps = {};

const reportColumns = new OrderedSet([
  ['enrolled', 'Enrolled'],
  ['active', 'Active'],
  ['overallRetention', 'Overall Retention'],
  ['adjustedRetention', 'Adjusted Retention'],
  ['totalDropped', 'Total Dropped'],
  ['involuntarilyDropped', '# dropped (involuntary)'],
  ['voluntarilyDropped', '# dropped (voluntary)'],
]);

const ReportSummaryView = ({ pathways, pathwayInstances, listPathwayInstances, currentUser, organizationId }) => {
  useEffect(() => {
    if (!pathwayInstances.size) {
      listPathwayInstances(currentUser, organizationId, { state: ['active', 'closed'] });
    }
  }, [currentUser, listPathwayInstances, organizationId, pathwayInstances]);

  return (
    <ReportSummaryStyles>
      {pathways.map((pathway) => (
        <React.Fragment key={pathway.get('id')}>
          <h2>{pathway.get('name')} Pathways Report</h2>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Pathway Instance Status</th>
                <th>Pathway Instance Start Date</th>
                <th>Enrolled</th>
                <th>Active</th>
                <th>Completed</th>
                <th>Overall Retention</th>
                <th>Adjusted Retention</th>
                <th>Total Dropped</th>
                <th># dropped (involuntary)</th>
                <th># dropped (voluntary)</th>
              </tr>
            </thead>
            <tbody>
              <TotalsSummary
                key="summary"
                pathwayInstances={pathwayInstances.filter((pathwayInstance) => pathwayInstance.getIn(['pathway', 'id']) === pathway.get('id'))}
              />
              {pathwayInstances
                .filter((pathwayInstance) => pathwayInstance.getIn(['pathway', 'id']) === pathway.get('id'))
                .map((pathwayInstance) => (
                  <PathwayInstanceSummary
                    key={pathwayInstance.get('id')}
                    reportColumns={reportColumns}
                    currentUser={currentUser}
                    pathwayInstance={pathwayInstance}
                  />
                ))}
            </tbody>
          </table>
          <br />
        </React.Fragment>
      ))}
    </ReportSummaryStyles>
  );
};

ReportSummaryView.propTypes = propTypes;
ReportSummaryView.defaultProps = defaultProps;

export default ReportSummaryView;
